import { MutableRefObject, useRef } from 'react';

export const useCurrentMutableStateRef = <T>(state: T): MutableRefObject<T> => {
  const metaRef = useRef(state);
  metaRef.current = state;
  return metaRef;
};
